import React from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';

import {CART_SECTION} from 'constants/analytics/events/cart';

import {BannerPropsType, CouponType} from '../../types';

import s from './cartBanner.scss';
type PropsType = {
    item: CouponType;
    onDetailsClick(): void;
};

const CartBannerItem: React.FC<PropsType> = ({item, onDetailsClick}) => {
    return (
        <li className={s.item}>
            <p className={s.title}>{item.title}</p>
            <div className={s.codeRow}>
                <span className={s.code}>Code: {item.code}</span>&nbsp;
                <button
                    aria-label="More Details"
                    className={s.moreDetailsBtn}
                    onClick={onDetailsClick}
                    type="button"
                >
                    More Details
                </button>
            </div>
        </li>
    );
};

/**
 *  CartBanner component at the bottom of cart sidebar coupons form
 */
export const CartBanner: React.FC<BannerPropsType> = ({data, openModal}) => {
    const {coupons} = data;
    const isCouponsEmpty = !coupons?.length;

    if (isCouponsEmpty) return null;

    const handleDetailsClick = (item: CouponType) => {
        sendDesktopAnalyticsEvent(CART_SECTION, {
            label: 'Learn More - Coupon',
            section: 'Right',
        });
        openModal(item.code);
    };

    return data.coupons.length > 0 ? (
        <ul className={s.list}>
            {data.coupons.map(item => (
                <CartBannerItem
                    item={item}
                    key={item.code}
                    onDetailsClick={() => handleDetailsClick(item)}
                />
            ))}
        </ul>
    ) : null;
};
